import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=0957a2d4&scoped=true"
import script from "./SalesOrder.vue?vue&type=script&lang=ts"
export * from "./SalesOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957a2d4",
  null
  
)

export default component.exports